import React from "react";
import { Link } from "gatsby"

import ImageModule from "../../modules/image_module";
import { PageLinks } from "../../common/page-links";

import "./Box.scss";

const Box = (props) => {
    const BoxList = props.BoxList;

    const ImageRenderList = ({item, imagename}) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.tile_image_Transforms) {
            processedImages = item?.imagetransforms?.tile_image_Transforms;
        }

        console.log("item ==>", item)
        return (
          <ImageModule ImageSrc={item.tile_image} title={item.title} altText={item.title} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={item.id} />                           
        )
    } 

    return (
        <React.Fragment>
            <div className="address-box">
                <div className="box">
                    <Link to={`/${PageLinks.our_brands}/${BoxList.slug}/`}>
                        <ImageRenderList item={BoxList} imagename={"brands.tile_image.thumbnail_image"} />
                    </Link>
                </div>
                <div className="box-content">
                    <Link to={`/${PageLinks.our_brands}/${BoxList.slug}/`}>
                        <div className="top-info">
                            
                                {BoxList.title}
                                <i className="icon-right"></i>
                            
                        </div>
                    </Link>
                </div>
            </div>
        </React.Fragment>
    );
};
export default Box;
